import * as fromEmployeeDetailReducer from '../reducers/employee-detail.reducer';
import * as fromDeceasedReducer from '../reducers/deceased.reducer';
import * as fromUpdateDeceasedReducer from '../reducers/update-deceased-reducer.reducer';
import * as fromBlockReducer from '../reducers/user-blocked.reducer';
import * as fromCheckBlockReducer from '../reducers/check-user-blocked.reducer';
import * as fromCheckLockReducer from '../reducers/check-user-locked.reducer';
import * as fromLockReducer from '../reducers/lock.reducer';
import * as fromGenerateOtpReducer from '../reducers/generate-otp.reducer';
import * as fromApproveFICAReducer from '../reducers/approve-fica.reducer';
import * as fromRemoveReducer from '../reducers/remove-user.reducer';
import * as fromCheckRemoveReducer from '../reducers/check-user-removed.reducer';
import * as fromUserRoleReducer from '../reducers/user-role.reducer';
import * as fromGovIdReducer from '../reducers/government-id.reducer';
import * as fromSelfieReducer from '../reducers/selfie.reducer';
import * as fromPreviousSelfieReducer from '../reducers/previous-selfie.reducer';
import * as fromApproveReducer from '../reducers/approve-documents.reducer';
import * as fromUnLockReducer from '../reducers/unlock.reducer';
import * as fromUnBLockReducer from '../reducers/user-unblocked.reducer';
import * as fromALIVEReducer from '../reducers/alive.reducer';
import * as fromRejectReducer from '../reducers/reject-document.reducer';
import * as fromHomeAddressReducer from '../reducers/home-address-current.reducer';
import * as fromPrivacySettingsReducer from '../reducers/privacy-settings.reducer';
import * as fromToDoReducer from '../reducers/to-dos.reducer';
import * as fromTaxYearsReducer from '../reducers/tax-years.reducer';
import * as fromSendTaxReducerReducer from '../reducers/send-tax-cert.reducer';
import * as fromGovIdProofReducer from '../reducers/gov-id-proof.reducer';
import * as fromOpenFileReducer from '../reducers/open-file.reducer';
import * as fromNoteReducer from '../reducers/note.reducer';
import * as fromRetirementPlanReducer from './retirement-plan.reducer';
import * as fromMonthlyIncomeReducer from '../reducers/monthly-income.reducer';
import * as fromLegalDocumentsCurrentReducer from '../reducers/legal-documents-current.reducer';
import * as fromLegalDocumentsPreviousReducer from '../reducers/legal-documents-previous.reducer';
import * as fromFNA from '../reducers/fna.reducer';
import * as fromStatements from '../reducers/statements.reducer';
import * as fromTransactionsAll from '../reducers/transactions-all.reducer';
import * as fromPreviousStatements from '../reducers/previous-statements.reducer';
import * as fromUpdateMobileNumberReducer from '../reducers/update-mobile-number.reducer';
import * as fromResignEmployeeReducer from '../reducers/resign-employee.reducer';
import * as fromGroupedProductsReducer from '../reducers/grouped-products.reducer';
import * as fromGroupedProductsForSomeoneElseReducer from '../reducers/grouped-products-for-someone-else.reducer';
import * as fromGroupedProductsFromSomeoneElseReducer from '../reducers/grouped-products-from-someone-else.reducer';
import * as fromEmployeeBusinessesReducer from '../reducers/employee-businesses.reducer';
import * as fromEmployeeWithdrawalsReducer from '../reducers/employee-withdrawals.reducer';
import * as fromEmployeeWithdrawalReducer from '../reducers/employee-withdrawal.reducer';
import * as fromEmployeeWithdrawalMarkAsRequestedReducer from '../reducers/employee-withdrawal-mark-as-requested.reducer';
import * as fromBankProofsReducer from '../reducers/bank-proof.reducer';
import * as fromApproveBankProofReducer from '../reducers/approve-bankproof.reducer';
import * as fromRejectBankProofReducer from '../reducers/reject-bankproof.reducer';
import * as fromDownloadPlaybacksReducer from '../reducers/download-playback-document.reducer';
import * as botflowPlaybackReducer from './botflow-playback.reducer';
import * as fromBankDetailsReducer from './bank-details.reducer';
import * as fromProfileStatusReducer from './profile-status.reducer';
import * as fromBankProofDocumentsReducer from './bankproof-documents.reducer';
import * as fromArchivedBankProofDocumentsReducer from './archived-bankproof-documents.reducer';
import * as fromApproveBankProofDocumentReducer from './approve-bankproof-document.reducer';
import * as fromRejectBankProofDocumentReducer from './reject-bankproof-document.reducer';
import * as fromAddBankReducer from './add-bank.reducer';
import * as fromUpdateBankReducer from './update-bank.reducer';
import * as fromRemoveBankReducer from './remove-bank.reducer';
import * as fromFilteredTransactions from '../reducers/filtered-transactions.reducer';
import * as fromUpdateMemberDetailReducer from './update-member-detail.reducer';
import * as fromComplianceReducer from './compliance.reducer';
import * as fromAddCharityBeneficiaryReducer from './add-charity-beneficiary.reducer';
import * as fromAddIndividualBeneficiaryReducer from './add-individual-beneficiary.reducer';
import * as fromAddTrustBeneficiaryReducer from './add-trust-beneficiary.reducer';
import * as fromEmployeeGovtIdDetailsReducer from './employee-govt-id-details.reducer';
import * as fromEmployeeHomeAddressReducer from './employee-home-address.reducer';
import * as fromDeleteCustomerReducer from './delete-customer.reducer';
import * as fromRestoreCustomerReducer from './restore-customer.reducer';

export {
  fromSendTaxReducerReducer,
  fromTaxYearsReducer,
  fromToDoReducer,
  fromPrivacySettingsReducer,
  fromHomeAddressReducer,
  fromRejectReducer,
  fromALIVEReducer,
  fromUnBLockReducer,
  fromUnLockReducer,
  fromApproveReducer,
  fromPreviousSelfieReducer,
  fromSelfieReducer,
  fromGovIdReducer,
  fromUserRoleReducer,
  fromCheckRemoveReducer,
  fromRemoveReducer,
  fromLockReducer,
  fromGenerateOtpReducer,
  fromApproveFICAReducer,
  fromCheckLockReducer,
  fromCheckBlockReducer,
  fromBlockReducer,
  fromUpdateDeceasedReducer,
  fromDeceasedReducer,
  fromEmployeeDetailReducer,
  fromGovIdProofReducer,
  fromOpenFileReducer,
  fromNoteReducer,
  fromRetirementPlanReducer,
  fromMonthlyIncomeReducer,
  fromLegalDocumentsCurrentReducer,
  fromLegalDocumentsPreviousReducer,
  fromFNA,
  fromStatements,
  fromTransactionsAll,
  fromPreviousStatements,
  fromUpdateMobileNumberReducer,
  fromResignEmployeeReducer,
  fromGroupedProductsReducer,
  fromGroupedProductsForSomeoneElseReducer,
  fromGroupedProductsFromSomeoneElseReducer,
  fromEmployeeBusinessesReducer,
  fromEmployeeWithdrawalsReducer,
  fromBankProofsReducer,
  fromApproveBankProofReducer,
  fromRejectBankProofReducer,
  fromEmployeeWithdrawalReducer,
  fromEmployeeWithdrawalMarkAsRequestedReducer,
  fromDownloadPlaybacksReducer,
  botflowPlaybackReducer,
  fromBankDetailsReducer,
  fromProfileStatusReducer,
  fromBankProofDocumentsReducer,
  fromArchivedBankProofDocumentsReducer,
  fromApproveBankProofDocumentReducer,
  fromRejectBankProofDocumentReducer,
  fromAddBankReducer,
  fromUpdateBankReducer,
  fromRemoveBankReducer,
  fromFilteredTransactions,
  fromUpdateMemberDetailReducer,
  fromComplianceReducer,
  fromAddCharityBeneficiaryReducer,
  fromAddIndividualBeneficiaryReducer,
  fromAddTrustBeneficiaryReducer,
  fromEmployeeGovtIdDetailsReducer,
  fromEmployeeHomeAddressReducer,
  fromDeleteCustomerReducer,
  fromRestoreCustomerReducer
};
